/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VaultList } from '../../models/vault-list';

export interface VaultGetList$Params {
}

export function vaultGetList(http: HttpClient, rootUrl: string, params?: VaultGetList$Params, context?: HttpContext): Observable<StrictHttpResponse<VaultList>> {
  const rb = new RequestBuilder(rootUrl, vaultGetList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VaultList>;
    })
  );
}

vaultGetList.PATH = '/vault/list';
